import React from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '@/components/Layout';
import MinimalLayout from '@/components/MinimalLayout';
import AdminLayout from '@/components/AdminLayout';

const AuthLayoutWrapper = ({ children, session }) => {
  const location = useLocation();
  const authRoutes = ["/subcontractor/login", "/subcontractor/register", "/admin/login", "/magic-link-confirmation", "/auth/callback"];
  const isAuthRoute = authRoutes.includes(location.pathname) || location.pathname.startsWith('/auth/callback');
  const isSubcontractorDashboardRoute = location.pathname.startsWith('/subcontractor/dashboard');
  const isAdminDashboardRoute = location.pathname.startsWith('/admin/dashboard');

  const isDriverSubdomain = window.location.hostname.includes('drivers.parcelink.org') ||
                            window.location.hostname.includes('drivers-local.parcelink.org');

  // Clients' partners.parcelink.org is a chrome-free, full-bleed immersive site.
  const isPartnersSubdomain = window.location.hostname.includes('partners.parcelink.org') ||
                              window.location.hostname.includes('partners-local.parcelink.org') ||
                              window.location.hostname.startsWith('partners.');

  // The apex parcelink.org splash is full-bleed with no app chrome.
  const isMainDomain = window.location.hostname === 'parcelink.org' ||
                       window.location.hostname === 'www.parcelink.org' ||
                       window.location.hostname === 'parcelink-local.parcelink.org';

  const isAccountingSubdomain = window.location.hostname.includes('accounting.parcelink.org') ||
                                window.location.hostname.includes('accounting-local.parcelink.org') ||
                                window.location.hostname.startsWith('accounting.');

  const isReceiptsSubdomain = window.location.hostname.includes('receipts.parcelink.org') ||
                              window.location.hostname.includes('receipts-local.parcelink.org') ||
                              window.location.hostname.startsWith('receipts.');

  const isOnboardingRoute = location.pathname.startsWith('/onboarding/');

  // runmark.co.uk is a DIFFERENT PRODUCT, not a page of this one. Falling
  // through to the app Layout served a prospective Runmark customer Parcelink's
  // logo, Parcelink's favicon and the ops shell gradient on the very page where
  // they were being asked to buy Runmark. It gets no app chrome at all, the way
  // the apex splash and the partners site already don't.
  const isControlPlane = window.location.hostname === 'runmark.co.uk' ||
                         window.location.hostname === 'www.runmark.co.uk' ||
                         window.location.hostname === 'runmark.localhost';

  // The accountant portal is a standalone surface with its OWN header and sign
  // out. Falling through to the app Layout wrapped it in a second set of
  // chrome — two headers, two paddings, and the portal squeezed inside a shell
  // built for the ops app, which is what broke it on a phone.
  const isAccountantPortal = location.pathname.startsWith('/accountant')
    // The partner portal is standalone in the same way, with the Smart Dash frame.
    || location.pathname.startsWith('/partner-portal')
    // So is the personal link a partner's introduced driver opens.
    || location.pathname.startsWith('/introduced/');

  // On the crew portal, "/" is the immersive full-screen subcontractor login,
  // which supplies its own brand background and header — it must render with no
  // app chrome. (accounting/receipts subdomains serve a different page at "/".)
  const isSubcontractorLoginRoot = location.pathname === '/' &&
                                   !isAccountingSubdomain && !isReceiptsSubdomain;

  if (isAuthRoute) {
    return <MinimalLayout>{children}</MinimalLayout>;
  }

  if (isControlPlane || isSubcontractorLoginRoot || isAdminDashboardRoute || isDriverSubdomain || isPartnersSubdomain || isMainDomain || isOnboardingRoute || isAccountantPortal) {
    return <>{children}</>;
  }

  if (isSubcontractorDashboardRoute) {
    return <Layout session={session} isDashboard={true}>{children}</Layout>;
  }

  return <Layout session={session} isDashboard={false}>{children}</Layout>;
};

export default AuthLayoutWrapper;